import { render, staticRenderFns } from "./MajorMinorPreviewActivity.vue?vue&type=template&id=b4412d36&scoped=true"
import script from "./MajorMinorPreviewActivity.vue?vue&type=script&lang=js"
export * from "./MajorMinorPreviewActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4412d36",
  null
  
)

export default component.exports